import React, { useEffect, useState } from 'react';
import { Card } from '../../ui/card';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Switch } from '../../ui/switch';
import { Label } from '../../ui/label';
import { Type, Plus, X, Save, Loader2 } from 'lucide-react';
import api from '../../../services/api';
import { toast } from '../../../hooks/use-toast';

export const TypewriterConfigCard = () => {
  const [config, setConfig] = useState(null);
  const [saving, setSaving] = useState(false);
  const [newPhrase, setNewPhrase] = useState('');

  useEffect(() => {
    api.get('/search/config').then(r => setConfig(r.data)).catch(() => setConfig({ is_typewriter_active: true, typewriter_phrases: [] }));
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await api.put('/search/admin/config', config, { headers: { Authorization: `Bearer ${localStorage.getItem('admin_token')}` } });
      toast({ title: 'Configuración guardada' });
    } catch {
      toast({ title: 'Error al guardar', variant: 'destructive' });
    } finally { setSaving(false); }
  };

  const addPhrase = () => {
    const t = newPhrase.trim();
    if (!t || config.typewriter_phrases.includes(t)) return;
    setConfig(p => ({ ...p, typewriter_phrases: [...p.typewriter_phrases, t] }));
    setNewPhrase('');
  };

  if (!config) return null;
  return (
    <Card className="bg-gray-800 border-gray-700 p-6" data-testid="typewriter-config">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-bold text-white flex items-center gap-2"><Type className="w-5 h-5 text-orange-400" /> Efecto Typewriter</h2>
        <div className="flex items-center gap-2">
          <Switch checked={config.is_typewriter_active} onCheckedChange={v => setConfig(p => ({ ...p, is_typewriter_active: v }))} data-testid="typewriter-toggle" />
          <Label className="text-gray-300 text-sm">{config.is_typewriter_active ? 'Activo' : 'Desactivado'}</Label>
        </div>
      </div>
      <div className="flex flex-wrap gap-2 mb-4">
        {config.typewriter_phrases.map((phrase, idx) => (
          <span key={idx} className="inline-flex items-center gap-2 bg-gray-900 rounded-full pl-3 pr-2 py-1.5 text-sm text-gray-300" data-testid={`typewriter-phrase-${idx}`}>
            {phrase}
            <button onClick={() => setConfig(p => ({ ...p, typewriter_phrases: p.typewriter_phrases.filter((_, i) => i !== idx) }))}
              className="text-gray-500 hover:text-red-400 transition-colors" data-testid={`typewriter-phrase-remove-${idx}`}><X className="w-3.5 h-3.5" /></button>
          </span>
        ))}
      </div>
      <div className="flex flex-wrap gap-2">
        <Input value={newPhrase} onChange={e => setNewPhrase(e.target.value)} onKeyDown={e => e.key === 'Enter' && addPhrase()}
          placeholder="Nueva frase..." className="bg-gray-900 border-gray-700 text-white flex-1 min-w-[200px]" data-testid="new-phrase-input" />
        <Button onClick={addPhrase} variant="outline" className="border-gray-600 text-gray-300 hover:text-white" data-testid="add-phrase-btn"><Plus className="w-4 h-4" /></Button>
        <Button onClick={save} disabled={saving} className="bg-orange-500 hover:bg-orange-600 text-white" data-testid="save-config-btn">
          {saving ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Save className="w-4 h-4 mr-2" />} Guardar
        </Button>
      </div>
    </Card>
  );
};
